import styled, { css } from 'styled-components';
import { DialogActions, DialogContent } from '@mui/material';
import { TextField as FormikTextField } from 'formik-mui';

import Dialog from 'components/mui/Dialog';
import DialogTitle from 'components/mui/DialogTitle';
import Doppler from 'components/Doppler';
import mainStyled from 'styles/main';

export default {
  Dialog: styled(Dialog)`
    max-width: 550px;
    margin: 0 auto;

    & form {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `,
  DialogTitle: styled(DialogTitle)`
    padding: 48px 16px 8px;
    & .MuiTypography-h5 {
      font-size: 1.875rem;
    }
  `,
  DialogTitleCaption: styled(Doppler)`
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1rem;
  `,
  DialogContent: styled(DialogContent)`
    padding: 8px 16px 0;
    overflow-y: hidden;
    ${({ $paddingBottom }) =>
      $paddingBottom &&
      css`
        padding-bottom: 40px;
      `}
  `,
  DialogActions: styled(DialogActions)`
    padding: 8px 16px 16px;
  `,
  TextField: styled(FormikTextField)`
    & .MuiInputBase-root {
      padding: 16px 24px;
    }
    & .MuiInputBase-input {
      padding: 0;
    }
    & .MuiInputBase-input {
      height: 185px;
    }
  `,
  IconSuccess: styled.div`
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: 1rem;
    animation: fadeIn 1s both;

    ${({ theme }) => {
      return css`
        background-color: ${theme.palette.success.main};
        color: ${theme.palette.background.dark.contrastText};

        ${theme.breakpoints.up('sm')} {
          margin-top: 0;
        }
      `;
    }};
  `,
  Typography: styled(mainStyled.Typography)`
    display: block;
    text-align: center;
    ${({ $marginTop }) => {
      if ($marginTop) {
        return css`
          margin: 16px auto 0;
        `;
      }
      return css`
        margin: 0 auto;
      `;
    }}
  `,
};
